import AxiosClient from './AxiosClient';
import { getHeaders, handleError } from './HttpUtil';

import type { IError, IConfigurationIdRequest } from '../../types/IApiTypes';

export const NotifyAPI = {
  notify: (action: IConfigurationIdRequest) =>
    AxiosClient.post(
      '/configurator/v1/configuration/notify/save',
      { configurationId: action.configurationId },
      { headers: getHeaders(action.token).headers }
    ).catch((err: IError) => {
      return handleError(err, 'notify');
    }),

  reset: (action: IConfigurationIdRequest) =>
    AxiosClient.post(
      '/configurator/v1/configuration/reset',
      { configurationId: action.configurationId },
      { headers: getHeaders(action.token).headers }
    ),
};
